module.exports = __webpack_public_path__ + "static/img/login-background.a9502f8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/login-background.jpeg
// module id = mn50
// module chunks = 1